import {ASSIGNMENT_STATUS} from "Services/assignment/constants";
import {activityStatus} from "Constants/constants";
import studentRecordService from "../../StudentRecordService";
import { logSessionInfo } from "../../logger";
import { isManifestItemIncomplete } from '@amira-rnd/student-shared-services/dist/utils';
import { getUserData } from "../../API";

/**
 * Determines if a manifest item is incomplete by checking if its status
 * is not one of the completed states (DONE, COMPLETE, or ERROR)
 * @param {Object} manifestItem The manifest item to check
 * @returns {boolean} true if the manifest item is incomplete, false otherwise
 */
export function getPendingTutorManifest(manifest, assignmentType) {
    const userData = getUserData();
    return manifest.filter((item) => isManifestItemIncomplete(
      item, 
      assignmentType, 
      userData.grade, 
      userData.automaticTextSetAssignments, 
      userData.automaticInstructAssignments
    ));
}

export default async function getPendingManifest(manifest){
  let filteredManifest = manifest.filter((item) => {
    const {status} = item;
    return status !== ASSIGNMENT_STATUS.DONE && status !== ASSIGNMENT_STATUS.COMPLETE;
  });

  // Update the sequence of the activity immediately preceding letterNamingAndSounds to BREAK as a work around
  for (let i = 1; i < filteredManifest.length; i++) {
    if (filteredManifest[i].activityType === "letterNamingAndSounds") {
      filteredManifest[i - 1].sequence = "BREAK";
    }
  }

  return filteredManifest;
}

function checkTutorAssignment(activity){
  return activity.status === activityStatus.ASSIGNED || (activity.status === "not_started" || (activity.status === "in_progress" && activity.displayStatus === "started")) && activity.type === "tutor"
}